export default __webpack_public_path__ + "static/media/ICTs (Institutos de Ciência e Tecnologia).7737df57.png";